import React from "react";
import { Box, Typography, Link } from "@mui/material";
import Header from "./home_layout_components/Header";
import Footer from "./home_layout_components/Footer";
import notFoundImage from "../../assets/404.png"; // 👈 add this

const NotFound = () => {
  return (
    <>
      <Header />
      <Box
        sx={{
          minHeight: "80vh",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          textAlign: "center",
          p: 3,
          backgroundColor: "#F5F7FA",
        }}
      >
        {/* 404 Icon */}
        <Box
          component="img"
          src={notFoundImage} // 👈 use the import here
          alt="404 Not Found"
          sx={{
            width: { xs: 220, sm: 340 },
            mt: -10,
          }}
        />

        <Typography variant="h5" sx={{ color: "text.secondary", mb: 1 }}>
          Oops! The page you're looking for doesn't exist.
        </Typography>

        <Link
          href="/"
          underline="none"
          sx={{
            mt: 2,
            px: 3,
            py: 1,
            borderRadius: "999px",
            fontSize: "1rem",
            fontWeight: 600,
            color: "#09b2f0",
            border: "2px solid #09b2f0",
            backgroundColor: "#FFFFFF",
            transition: "all 0.2s ease",
            "&:hover": {
              backgroundColor: "#09b2f0",
              color: "#FFFFFF",
            },
          }}
        >
          ← Back to home
        </Link>
      </Box>
      <Footer />
    </>
  );
};

export default NotFound;
